import { useBreakpoint, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { useState } from 'react';
import ContentHeaderCard from '../ConentHeaderCard/ContentHeaderCard';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import styles from './ArticleOverview.module.scss';
import { type ArticleOverviewProps } from './types/propsTypes';

const ArticleOverview = (props: ArticleOverviewProps) => {
  const viewPortType = useBreakpoint();
  const [imgLoading, setImgLoading] = useState(true);
  const image = props?.imageList?.find((item) => item?.viewport.includes(viewPortType));
  const { tag, description, title, subTitle, audioFile } = props;

  return (
    <div className={`${styles['article-overview-container']}`} data-testid={`article-overview-container-testid`}>
      <div className={styles['article-banner-image-container']}>
        <NextgenImage
          src={image?.url ?? ''}
          className={imgLoading ? styles['article-banner-image-hidden'] : styles['article-banner-image']}
          onLoad={() => setImgLoading(false)}
          alt={image?.altText ?? ''}
          loaderType={LoaderType.CONTENTSTACK}
        />
        {imgLoading && <SkeletonLoader height={544} borderRadius={0} />}
      </div>
      <div className={styles['content-card']}>
        <ContentHeaderCard
          tag={tag}
          description={description}
          title={title}
          subTitle={subTitle}
          audioFile={audioFile}
        />
      </div>
    </div>
  );
};

export default ArticleOverview;
